import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function ProcurementSavingsCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.mgmtSavingsChart !== 'undefined') {
      window.mgmtSavingsChart.canvas = chartRef.current;
      window.mgmtSavingsChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Procurement Savings</h3>
        <span className="click-tag">Click bars for details</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="mgmtSavingsChart" ref={chartRef}></canvas>
      </div>
      <div id="mgmtSavingsDetail" style={{ marginTop: 12, display: 'none', padding: 12, background: 'var(--bg)', borderRadius: 8, fontSize: '12px', color: 'var(--text-sec)' }}></div>
    </Box>
  );
}
